export default __webpack_public_path__ + "static/media/empty-draft.43a4e5d2.svg";